import styled from 'styled-components'
import { Select as AntdSelect } from 'antd'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
export const StyledSelect = styled(AntdSelect)`
  width: calc(100% - 10px) !important;
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_BASE};
  line-height: 24px;
  color: ${COLORS.GREY_T_40};

  .ant-select-item-group {
    color: ${COLORS.BLACK} !important;
    font-size: ${FONT.F_XS};
    cursor: default;
  }
  .ant-select-selector {
    background-color: ${props =>
      props.backgroundcolor ? props.backgroundcolor : '#ffffff'} !important;
    border-radius: 8px !important;
    border-color: #e9e9e9 !important;
    box-shadow: none !important;
    height: 48px !important;
    padding: 7px 11px !important;
  }
  .ant-select-selection-item {
    background-color: transparent;
    color: ${COLORS.GREY_P_100};
    padding-top: 10px;
  }
  :hover {
    background-color: transparent;
  }
  .ant-select-dropdown-placement-bottomLeft {
    width: 100px !important;
  }
  .ant-select-selection-item-remove {
    display: flex;
    align-items: center;
  }
  .aant-select.ant-select-in-form-item.ant-select-single.ant-select-show-arrow {
    width: 100% !important;
  }
`
